import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Locationlisting(props) {
  return (
    <section className="p-100 pt-0">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="seriveces_listing page_listing"
          >
            <div className="example" data-text="USA">
              <h2>USA</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Florida</h4>
              <div className="location_menus">
                <Link to="/app-development-florida">
                  App Developers in Florida
                </Link>
                <Link to="/software-development-florida">
                  Software Development Florida
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>San Francisco</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/app-developers-san-francisco">
                  App Developers San Francisco
                </Link>
                <Link to="/software-development-san-francisco">
                  Software Development San Francisco
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Washington DC</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/app-development-washington-dc">
                  App Developers in Washington DC
                </Link>
                <Link to="/software-development-washington">
                  Software Development Washington DC
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Los Angeles</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/app-development-los-angeles">
                  App Development in Los Angeles
                </Link>
                <Link to="/software-development-los-angeles">
                  Software Development Los Angeles
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Dallas</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/app-development-dallas">
                  App Developers in Dallas
                </Link>
                <Link to="/software-development-dallas">
                  Software Development Company Dallas
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Houston</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/houston-app-development">
                  App Developers in Houston
                </Link>
                <Link to="https://www.tekrevol.com/software-development-houston">
                  Software Development Company Houston
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Austin</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/app-development-austin">
                  Mobile app development Austin
                </Link>
                <Link to="/software-development-austin">
                  Software Development Company Austin
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Chicago</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/app-development-chicago">
                  Mobile App Development in Chicago
                </Link>
                <Link to="/software-development-chicago">
                  Software Development Company Chicago
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>New York</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-new-york-city">
                  App Developers in NYC
                </Link>
                <Link to="/software-development-new-york-city">
                  Software Development Company New York
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Miami</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/app-developer-miami">
                  App Developers in Miami
                </Link>
                <Link to="/software-development-miami">
                  Software Development Company Miami
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>New Jersey</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/website-design-development-nj">
                  Web Design Company In NJ
                </Link>
                <Link to="/software-development-new-jersey">
                  Software Development company NJ
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Texas</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-texas">
                  Mobile App Development Texas
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>San Diego</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-san-diego">
                  Mobile App Development San Diego
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Atlanta</h4>
              <div className="location_menus">
                <Link to="/mobile-app-development-atlanta">
                  Mobile App Development Atlanta
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Denver</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-denver">
                  Mobile App Development Denver
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Indianapolis</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-indianapolis">
                  Mobile App Development Indianapolis
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>California</h4>
              <div className="location_menus">
                <Link to="/mobile-app-development-california">
                  Mobile App Development California
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Boston</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-boston">
                  Mobile App Development Boston
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Ohio</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-ohio">
                  Mobile App Development Ohio
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="seriveces_listing page_listing"
          >
            <div className="example" data-text="GCC">
              <h2>GCC</h2>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Bahrain</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/bh/mobile-app-development-company-bahrain">
                  App Development Company Bahrain
                </Link>
              </div>
            </div>
            <div className="item_listing add_loc">
              <h4>Qatar</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/qa/mobile-app-development-company-qatar">
                  App Development Company Qatar
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Dubai</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/mobile-app-development-company-dubai">
                  App Development Company Dubai
                </Link>
                <Link to="/ae/app-marketing-company-dubai">
                  App Marketing Company Dubai
                </Link>
                <Link to="https://www.tekrevol.com/ae/custom-software-development-dubai">
                  Custom Software Development Dubai
                </Link>
                <Link to="https://www.tekrevol.com/ae/game-development-dubai">
                  Game Development Company Dubai
                </Link>
                <Link to="/android-app-development-dubai">
                  Android App Development Dubai
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4></h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/ae/web-development-dubai">
                  Web Development Company Dubai
                </Link>
                <Link to="/hire-mobile-app-developers-dubai">
                  Hire Mobile App Developers Dubai
                </Link>
                <Link to="/iphone-app-development-dubai">
                  Iphone App Development Dubai
                </Link>
                <Link to="/flutter-app-development-dubai">
                  Flutter App Development Dubai
                </Link>
                <Link to="/react-native-app-development-dubai">
                  React Native App Development Dubai
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Saudi Arabia</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/sa/mobile-app-development-saudi-arabia">
                  App Development Company Saudi Arabia
                </Link>
                <Link to="/hire-mobile-app-developers-in-saudi-arabia">
                  Hire Mobile App Developers Saudi Arabia
                </Link>
                <Link to="/sa/website-development-in-saudi-arabia">
                  Website Development Saudi Arabia
                </Link>
                <Link to="/sa/game-development-company-saudi-arabia">
                  Game Development Saudi Arabia
                </Link>
                <Link to="/sa/custom-software-development-saudi-arabia">
                  Custom Software Development Saudi Arabia
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="seriveces_listing page_listing"
          >
            <div className="example" data-text="Canada">
              <h2>Canada</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>Toronto</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/ca/app-development-toronto">
                  App Development Company Toronto
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="seriveces_listing page_listing"
          >
            <div className="example" data-text="Uk">
              <h2>UK</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="item_listing add_loc">
              <h4>London</h4>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/uk/mobile-app-development-company-uk">
                  UK Mobile App Development
                </Link>
              </div>
              <div className="location_menus">
                <Link to="https://www.tekrevol.com/uk/web-development-company-uk">
                  UK Web App Development
                </Link>
              </div>
              <div className="location_menus">
                <Link to="/uk/custom-software-development-company-london">
                  UK Custom Software Development
                </Link>
              </div>
              <div className="location_menus">
                <Link to="/uk/game-development-company-london">
                  UK Game Development
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <h4></h4>
            <div className="item_listing add_loc">
              <div className="location_menus">
                <Link to="/uk/android-app-development-company-london">
                  UK Android App Development
                </Link>
              </div>
              <div className="location_menus">
                <Link to="/uk/ios-app-development-company-london">
                  UK iOS App Development
                </Link>
              </div>
              <div className="location_menus">
                <Link to="/uk/react-native-app-development-company-uk">
                  UK React Native App Development
                </Link>
                <Link to="/uk/flutter-app-development-company-london">
                  UK Flutter App Development
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Locationlisting;
